import classes from '../buttons/button.module.css'

const CreateButton = ({text, onClick}) => {
    return (
        <button className={`${classes.submit}`} onClick={onClick}>
            + {text}
        </button>
    )
};

export default CreateButton;